import React from 'react'
import ReactDOM from 'react-dom'
import { ReactSVG } from 'react-svg'
import { inject, observer } from 'mobx-react';

@inject('workAreaStore') @observer
class SVGLayer extends React.Component {

  constructor(props){
    super(props)
    this.state = {
      data: null
    }
  }

  componentDidMount(){
    this.setSVGHtml()
  }

  setSVGHtml(){
    this.setState({
      data: this.props.dataSource
    })
  }

  componentDidUpdate(prevProps){
    if(prevProps.dataSource !== this.props.dataSource){
      this.setState({
        data: this.props.dataSource
      })
    }
  }

  render(){
    const { id, dataSource, frameHeight, frameWidth, boxWidth, boxHeight, boxX, boxY } = this.props
    return (
      <div 
        className='public-svg' 
        style={{
          width: frameWidth,
          height: frameHeight
        }}
        data-id={btoa(id)}
        dangerouslySetInnerHTML={{__html: this.state.data}}
      > 
      </div>
    )
  }

}

export default SVGLayer